import{createContext as o}from"react";const t=o(void 0);export{t as default};
